export default __webpack_public_path__ + "static/passport-850ede9174fc674dda9431a636c50ec5.png";